/**
 * System Lizard - Factory & User Preset Manager
 */

export const FACTORY_PRESETS = [
  {
    name: "Chaotic Lizard Drone",
    params: {
      coarseFreq: 110,
      fineFreq: 0,
      radius: 1.414,
      shape: 0.85,
      fmDepth: 0.6,
      delayTime: 0.35,
      feedback: 0.75,
      mix: 0.5
    }
  },
  {
    name: "Subharmonic Bass Kraut",
    params: {
      coarseFreq: 65,
      fineFreq: -5,
      radius: 0.5,
      shape: 0.2,
      fmDepth: 0.15,
      delayTime: 0.12,
      feedback: 0.3,
      mix: 0.25
    }
  },
  {
    name: "Cybernetics Lead",
    params: {
      coarseFreq: 440,
      fineFreq: 12,
      radius: 2.0,
      shape: 0.45,
      fmDepth: 0.35,
      delayTime: 0.25,
      feedback: 0.4,
      mix: 0.35
    }
  },
  {
    name: "Resonant Metallic Noise",
    params: {
      coarseFreq: 880,
      fineFreq: -20,
      radius: 3.1415,
      shape: 0.95,
      fmDepth: 0.85,
      delayTime: 0.05,
      feedback: 0.88,
      mix: 0.6
    }
  }
];

export class PresetManager {
  constructor(synthEngine, onPresetLoad) {
    this.synth = synthEngine;
    this.onPresetLoad = onPresetLoad;
  }

  loadPreset(preset) {
    for (const [key, val] of Object.entries(preset.params)) {
      this.synth.setParam(key, val);
    }
    if (this.onPresetLoad) {
      this.onPresetLoad(preset);
    }
  }

  exportPresetJSON() {
    return JSON.stringify({
      name: "Custom Lizard Patch",
      params: { ...this.synth.params }
    }, null, 2);
  }
}
